
import React from 'react';

export default function ActionItemInformationPage2() 
{
    return ( 
        <> 
            <div class="row">
                <div class="col-1 mt-1">
                    <a href="#"><img class="card-icon" src="./images/file.svg" alt="file" border="0"/></a>                     
                </div>
                <div class="col">
                    Location of all Action File Attachments. All files are saved in reliable cloud storage accessable anywhere on any device.
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-1">
                    <a href="#"><img class="card-icon" src="./images/form.svg" alt="form" border="0"/></a>
                </div>
                <div class="col">
                    Action Details Form
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-1 mt-2">
                    <a href="#"><img class="card-icon" src="./images/comments.svg" alt="comments" border="0"/></a>
                </div>
                <div class="col">
                   Action Comments. An Action Assignee can add notes to themselves. Team Members (if this is Action is not part of a private List)
                    may add their input and feedback.
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-1 mt-2">
                    <a href="#"><img class="card-icon" src="./images/history.svg" alt="history" border="0"/></a>
                </div>
                <div class="col">
                    Here you will find a history of all Action activities throughout the life of the Action. Both Team Lists and Users also have their own
                    history events.                
                </div>
            </div>

        </> 
    );
}
